import {
  Box,
  Menu,
  Grid,
  Modal,
  Stack,
  Table,
  Collapse,
  TableRow,
  MenuItem,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  IconButton,
  Pagination,
  TableContainer,
  MenuItem as MuiMenuItem,
} from "@mui/material";
import {
  Search,
  FilterList,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import {
  getOfflineTransactions,
  deleteOfflineTransaction,
} from "../../../services/account/offline-transaction";
import moment from "moment";
import Swal from "sweetalert2";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { errorMsg } from "../../../utils/toast-msg";
import { ThemeProvider } from "@mui/material/styles";
import EditMenu from "../../../assets/image/Frame.svg";
import { errorAlert } from "../../../utils/error-alert";
import { deleteAlert } from "../../../utils/delete-alert";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ResetIcon from "../../../assets/image/reseticon.svg";
import { successAlert } from "../../../utils/success-alert";
import PrintIcon from "../../../assets/image/PrintButton.svg";
import { PaginationTheme } from "../../../components/PaginationTheme";
import { CustomSearchInput } from "../../../components/CustomSearchInput";
import { CustomPaginationSelect } from "../../../components/CustomPaginationSelect";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "12px",
};

const serviceTypes = [
  { name: "AIR TICKET", color: "var(--color-service-air)" },
  { name: "VISA", color: "var(--color-service-visa)" },
  { name: "HOTEL", color: "var(--color-service-hotel)" },
  { name: "TRANSPORT", color: "var(--color-service-transport)" },
  { name: "TOUR", color: "var(--color-service-tour)" },
  { name: "UMRAH", color: "var(--color-service-umrah)" },
  { name: "HAJJ", color: "var(--color-service-hajj)" },
  { name: "PACKAGE", color: "var(--color-service-package)" },
  { name: "FLIGHT", color: "var(--color-service-flight)" },
  { name: "OTHERS", color: "var(--color-service-others)" },
];

const getServiceColor = (service) => {
  const serviceType = serviceTypes.find((s) => s.name === service);
  return serviceType ? serviceType.color : "var(--color-service-others)";
};

const OfflineServiceList = () => {
  const navigate = useNavigate();

  const [show, setShow] = useState({});
  const [data, setData] = useState({});
  const [csvData, setCsvData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [limit, setLimit] = useState(20);
  const [pageCount, setPageCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [expanded, setExpanded] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchString, setSearchString] = useState("");
  const [fileModal, setFileModal] = useState(false);
  const [documentUrl, setDocumentUrl] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const query = {
          limit: limit,
          page: pageNumber,
          searchString: searchString,
        };

        const {
          data: {
            payload: { data: transactions, meta: meta },
          },
        } = await getOfflineTransactions(query);

        setCsvData(transactions);
        setSearchData(transactions);
        setTransactions(transactions);
        setPageCount(meta?.totalPages);
      } catch (error) {
        if (error?.response?.status === 403) {
          errorMsg("You have no permission to access this page");
        } else {
          console.error("An error occurred while fetching data:", error);
          errorMsg("An unexpected error occurred. Please try again later.");
        }
      }
    })();
  }, [limit, pageNumber, searchString]);

  const handleShow = ({ type, payload }) => {
    setData(payload);
    setShow({ ...show, [type]: true });
  };

  const handleClose = (type) => {
    setData({});
    setShow({ ...show, [type]: false });
  };

  const handleDelete = async () => {
    setShow({});
    setAnchorEl(false);

    deleteAlert("Are you sure you want to delete this trx?").then(
      async (result) => {
        if (result.isConfirmed) {
          const result = await deleteOfflineTransaction(data.id);
          if (result.error) errorAlert(result.error.data.message);
          setCsvData(csvData.filter((item) => item.id != data.id));
          setSearchData(searchData.filter((item) => item.id != data.id));
          setData({});
          setTransactions(transactions.filter((item) => item.id != data.id));
          successAlert("Offline Trx deleted successfully");
        }
      },
    );
  };

  const handelSearchItems = (e) => {
    setSearchString(e.target.value);
  };

  const handlePageChange = (event, value) => {
    setPageNumber(value);
  };

  const handlePageView = (value) => {
    setLimit(value);
  };

  const handleExpandClick = (id) => {
    setExpanded((prev) => (prev === id ? null : id));
  };

  const handleFileClick = (scanCopyUrl, referenceId) => {
    if (scanCopyUrl) {
      setFileModal(true);
      setDocumentUrl(scanCopyUrl);
    } else {
      Swal.fire({
        title: "No Document",
        text: "No scanned copy available for this transaction.",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <Box sx={{ marginTop: { xs: "20px", sm: "0", md: "0" } }}>
      {/* Table Section */}
      <Box
        sx={{
          padding: "16px",
          backgroundColor: "var(--color-bg-white)",
          borderRadius: "12px",
        }}
      >
        {/* Top Bar */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "flex-start", sm: "space-between" },
            alignItems: { xs: "flex-start", sm: "center" },
            borderRadius: "12px",
            gap: { xs: 2, sm: 0 },
          }}
          mb={2}
        >
          {/* Left Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: "12px",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {/* Quick Search */}
            <Box
              sx={{
                position: "relative",
                width: { xs: "100%", sm: "auto" },
              }}
              className={"placeholderColor"}
            >
              <Search
                sx={{
                  position: "absolute",
                  top: "7px",
                  left: "5px",
                  color: "var(--color-draft)",
                }}
              />
              <CustomSearchInput
                onChange={handelSearchItems}
                type="text"
                placeholder="Quick Search"
                sx={{
                  padding: "0px 32px",
                  backgroundColor: "var(--color-bg-hover-sitebar)",
                  width: "100%",
                }}
              />
            </Box>

            {/* View Dropdown */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "var(--color-bg-hover-sitebar)",
                borderRadius: "4px",
                padding: "5px 5px",
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Outfit",
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "var(--color-draft)",
                  paddingRight: "10px",
                }}
              >
                View
              </Typography>
              <CustomPaginationSelect
                onChange={(e) => handlePageView(e.target.value)}
                defaultValue={10}
                sx={{
                  backgroundColor: "var(--color-bg-white)",
                  height: "25px",
                  border: "none",
                  color: "var(--color-draft)",
                  width: "100%",
                }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </CustomPaginationSelect>
            </Box>

            {/* Filter */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "var(--color-bg-hover-sitebar)",
                borderRadius: "4px",
                padding: "5px 5px",
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Outfit",
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "var(--color-draft)",
                  paddingRight: "10px",
                }}
              >
                Filter
              </Typography>
              <FilterList
                sx={{
                  color: "var(--color-draft)",
                  backgroundColor: "var(--color-bg-white)",
                  padding: "2px 4px",
                  fontSize: "22px",
                  borderRadius: "5px",
                }}
              />
            </Box>

            {/* Reset */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "var(--color-bg-hover-sitebar)",
                borderRadius: "4px",
                padding: "5px 5px",
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Outfit",
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "var(--color-draft)",
                  paddingRight: "10px",
                }}
              >
                Reset
              </Typography>
              <img
                src={ResetIcon}
                alt="Reset"
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: "var(--color-bg-white)",
                  padding: "6px 6px",
                  borderRadius: "5px",
                }}
              />
            </Box>
          </Box>

          {/* Right Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "row", sm: "row" },
              gap: "12px",
              alignItems: "center",
              justifyContent: { xs: "flex-start", sm: "space-between" },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {/* Add Party Button */}
            <button
              style={{
                backgroundColor: "var(--color-primary-dark)",
                color: "var(--color-bg-white)",
                borderRadius: "5px",
                padding: "10px 12px",
                fontFamily: "Outfit",
                fontSize: "13px",
                fontWeight: 500,
                textTransform: "none",
                boxShadow: "none",
                border: "none",
                display: "flex",
                gap: "5px",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() =>
                navigate("/dashboard/transactions/create-offline-service/new")
              }
            >
              Add Offline Transaction
            </button>

            {/* Print CSV */}
            <CSVLink data={csvData}>
              <img
                src={PrintIcon}
                alt="Print"
                style={{
                  height: "35px",
                  cursor: "pointer",
                }}
              />
            </CSVLink>
          </Box>
        </Box>

        <TableContainer sx={{ backgroundColor: "var(--color-bg-white)" }}>
          <Table
            sx={{
              minWidth: "900px",
              tableLayout: "auto",
              backgroundColor: "var(--color-bg-white)",
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "var(--color-primary-light)",
                  color: "var(--color-bg-white)",
                  fontWeight: "500",
                }}
              >
                <TableCell sx={{ padding: "4px", textAlign: "center" }} />

                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  Date
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  Service
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  Service Category
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  Vendor
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  Agent
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  Vendor Payble
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  User Payable
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  Profit Loss
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "var(--color-bg-white)",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    padding: "4px",
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {searchData?.map((trx) => (
                <React.Fragment key={trx.id}>
                  <TableRow
                    sx={{
                      backgroundColor:
                        expanded === trx.id
                          ? "var(--color-bg-hover-sitebar)"
                          : "var(--color-bg-white)",
                    }}
                  >
                    <TableCell sx={{ textAlign: "center", padding: "4px" }}>
                      <IconButton
                        sx={{
                          color: "var(--color-draft)",
                          border: "solid var(--color-draft) 1px",
                          width: "18px",
                          height: "18px",
                        }}
                        size="small"
                        onClick={() => handleExpandClick(trx.id)}
                      >
                        {expanded === trx.id ? (
                          <ExpandLess fontSize="small" />
                        ) : (
                          <ExpandMore fontSize="small" />
                        )}
                      </IconButton>
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "var(--color-gray)",
                        fontFamily: "Outfit",
                        padding: "4px",
                      }}
                    >
                      {trx.date ? moment(trx.date).format("DD-MMM-YYYY") : null}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "var(--color-gray)",
                        fontFamily: "Outfit",
                        padding: "4px",
                      }}
                    >
                      {trx.service &&
                        !["wallet", "all"].includes(
                          trx.service?.toLowerCase(),
                        ) && (
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                              backgroundColor: "var(--Boxider-bg)",
                              padding: "5px",
                              borderRadius: "2px",
                            }}
                          >
                            {trx.service && (
                              <Box
                                component="span"
                                sx={{
                                  width: "6px",
                                  height: "6px",
                                  borderRadius: "50%",
                                  backgroundColor: getServiceColor(trx.service),
                                  marginRight: "8px",
                                }}
                              ></Box>
                            )}
                            {trx.service}
                          </Box>
                        )}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "var(--color-gray)",
                        fontFamily: "Outfit",
                        padding: "4px",
                      }}
                    >
                      {trx.serviceCategory && trx.serviceCategory !== "ALL"
                        ? trx.serviceCategory === "CL_ADD"
                          ? "CL Add"
                          : trx.serviceCategory === "CL_CLEAR"
                            ? "CL Clear"
                            : trx.serviceCategory === "MFS"
                              ? "MFS"
                              : trx.serviceCategory
                                  .toLowerCase()
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase(),
                                  )
                        : ""}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "var(--color-gray)",
                        fontFamily: "Outfit",
                        padding: "4px",
                      }}
                    >
                      {trx?.vendor ? (
                        <>
                          <Typography
                            sx={{
                              textAlign: "center",
                              fontWeight: 500,
                              fontSize: "12px",
                              color: "var(--color-airline-code)",
                              fontFamily: "Outfit",
                            }}
                          >
                            {trx?.vendor?.vendorName}
                          </Typography>
                          <Box
                            sx={{
                              backgroundColor: "var(--color-bg-hover-sitebar)",
                              display: "inline-flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "10px",
                              padding: "2px 8px",
                              marginTop: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <span
                              style={{
                                width: "7px",
                                height: "7px",
                                backgroundColor: "var(--color-danger)",
                                borderRadius: "50%",
                                display: "inline-block",
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "10px",
                                color: "var(--color-airline-code)",
                                fontFamily: "Outfit",
                                fontWeight: 400,
                                padding: "2px 10px",
                                borderRadius: "12px",
                              }}
                            >
                              {trx?.vendor?.identificationShortCode}
                            </Typography>
                          </Box>
                        </>
                      ) : null}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "var(--color-gray)",
                        fontFamily: "Outfit",
                        padding: "4px",
                      }}
                    >
                      {trx?.b2bUser ? (
                        <>
                          {" "}
                          <Typography
                            sx={{
                              textAlign: "center",
                              fontWeight: 500,
                              fontSize: "12px",
                              color: "var(--color-airline-code)",
                              fontFamily: "Outfit",
                            }}
                          >
                            {trx?.b2bUser?.companyName}
                          </Typography>
                          <Box
                            sx={{
                              backgroundColor: "var(--color-bg-hover-sitebar)",
                              display: "inline-flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "10px",
                              padding: "2px 8px",
                              marginTop: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <span
                              style={{
                                width: "7px",
                                height: "7px",
                                backgroundColor: "var(--color-danger)",
                                borderRadius: "50%",
                                display: "inline-block",
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "10px",
                                color: "var(--color-airline-code)",
                                fontFamily: "Outfit",
                                fontWeight: 400,
                                padding: "2px 10px",
                                borderRadius: "12px",
                              }}
                            >
                              {trx?.b2bUser?.identificationShortCode}
                            </Typography>
                          </Box>
                        </>
                      ) : null}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "var(--color-gray)",
                        fontFamily: "Outfit",
                        padding: "4px",
                      }}
                    >
                      {(+trx.vendorPayable || 0).toFixed(2)}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "var(--color-gray)",
                        fontFamily: "Outfit",
                        padding: "4px",
                      }}
                    >
                      {(+trx.userPayable || 0).toFixed(2)}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "var(--color-gray)",
                        fontFamily: "Outfit",
                        padding: "4px",
                      }}
                    >
                      {(
                        (+trx.userPayable || 0) - (+trx.vendorPayable || 0)
                      ).toFixed(2)}
                    </TableCell>

                    <TableCell
                      align="right"
                      sx={{
                        padding: "6px !important",
                        verticalAlign: "middle",
                        textDecoration: "none",
                      }}
                    >
                      {trx.scanCopyUrl && (
                        <IconButton
                          onClick={() => handleFileClick(trx.scanCopyUrl)}
                          sx={{ padding: 0 }}
                        >
                          <AttachFileIcon
                            sx={{
                              fontSize: "16px",
                              color: "var(--color-draft)",
                            }}
                          />
                        </IconButton>
                      )}

                      <IconButton
                        size="small"
                        onClick={(event) => {
                          setAnchorEl(event.currentTarget);
                          handleShow({ type: "action", payload: trx });
                        }}
                      >
                        <img
                          src={EditMenu}
                          alt="Options"
                          style={{ width: "10px" }}
                        />
                      </IconButton>
                      <Menu
                        keepMounted
                        open={show.action}
                        anchorEl={anchorEl}
                        onClose={() => {
                          setAnchorEl(null);
                          handleClose("action");
                        }}
                      >
                        <MuiMenuItem
                          sx={{
                            color: "var(--color-gray)",
                            fontSize: "12px",
                            fontWeight: 300,
                            fontFamily: "Outfit",
                            "&:hover": {
                              backgroundColor: "var(--color-bg-hover-sitebar)",
                              color: "var(--color-gray)",
                            },
                          }}
                          onClick={() => {
                            navigate(
                              `/dashboard/transactions/create-offline-service/${data.id}`,
                            );
                          }}
                        >
                          Edit
                        </MuiMenuItem>

                        <MuiMenuItem
                          sx={{
                            color: "var(--color-danger)",
                            fontSize: "12px",
                            fontWeight: 300,
                            fontFamily: "Outfit",
                            "&:hover": {
                              backgroundColor: "var(--color-bg-hover-sitebar)",
                              color: "var(--color-gray)",
                            },
                          }}
                          onClick={handleDelete}
                        >
                          Delete
                        </MuiMenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                        backgroundColor: "var(--color-bg-hover-sitebar)",
                      }}
                      colSpan={10}
                    >
                      <Collapse
                        in={expanded === trx.id}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box py={1}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <Box sx={{ display: "flex", gap: "10px" }}>
                                <Typography
                                  sx={{
                                    backgroundColor: "var(--color-bg-white)",
                                    color: "var(--color-gray)",
                                    fontFamily: "Outfit",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    width: "fit-content",
                                    padding: "2px 10px",
                                    borderRadius: "10px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "var(--color-draft)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Remarks :{trx.remarks || "N/A"}
                                  </span>
                                  {""}
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Box sx={{ display: "flex", gap: "10px" }}>
                                <Typography
                                  sx={{
                                    color: "var(--color-gray)",
                                    fontFamily: "Outfit",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    width: "fit-content",
                                    padding: "2px 10px",
                                    borderRadius: "10px",
                                  }}
                                >
                                  Created By:
                                  <span
                                    style={{
                                      color: "var(--color-primary)",
                                      fontFamily: "Outfit",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {" "}
                                    {trx?.createdByUser?.firstname},{" "}
                                    {
                                      trx?.createdByUser
                                        ?.identificationShortCode
                                    }
                                  </span>
                                  {" | "}
                                  <span
                                    style={{
                                      color: "var(--color-booking-id)",
                                      fontFamily: "Outfit",
                                      fontWeight: 400,
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {moment(trx?.createdDateTime).format(
                                      "DD-MMM-YY h:mm A",
                                    )}
                                  </span>
                                </Typography>

                                <Typography
                                  sx={{
                                    color: "var(--color-gray)",
                                    fontFamily: "Outfit",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    width: "fit-content",
                                    padding: "2px 10px",
                                    borderRadius: "10px",
                                  }}
                                >
                                  Updated By:{" "}
                                  <span
                                    style={{
                                      color: "var(--color-primary)",
                                      fontFamily: "Outfit",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {" "}
                                    {trx?.updatedByUser?.firstname},{" "}
                                    {
                                      trx?.updatedByUser
                                        ?.identificationShortCode
                                    }
                                  </span>
                                  {" | "}
                                  <span
                                    style={{
                                      color: "var(--color-booking-id)",
                                      fontFamily: "Outfit",
                                      fontWeight: 400,
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {moment(trx?.updatedDateTime).format(
                                      "DD-MMM-YY h:mm A",
                                    )}
                                  </span>
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {transactions.length ? (
          <Box
            sx={{
              width: "100%",
              mt: 2,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ThemeProvider theme={PaginationTheme}>
              <Stack spacing={2}>
                <Pagination
                  count={pageCount}
                  page={pageNumber}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Stack>
            </ThemeProvider>
          </Box>
        ) : null}
      </Box>

      <Modal
        open={fileModal}
        onClose={() => setFileModal(false)}
        BackdropProps={{
          style: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box sx={{ ...modalStyle }}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={() => setFileModal(false)}
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                color: "var(--color-bg-white)",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            <img
              src={documentUrl}
              alt="Document"
              style={{
                borderRadius: "20px",
                maxHeight: "80vh",
                maxWidth: "80vw",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default OfflineServiceList;
